import AppLayout from "../components/app-layoout";
import {
  Button,
  Box,
  Stack,
  Typography,
  styled,
  Divider,
  Grid,
} from "@mui/material";
import { LayoutContainer } from "../components/app-layoout/container";
import TransactionHistory from "../components/Transactions/TransactionHistory";
import TokenCard from "../components/Transactions/TokenCard";
import BalanceCard from "../components/Transactions/BalanceCard";
import { useUserData } from "../hooks/use-data-user";
import { useTokensData } from "../hooks/use-tokens-data";
import { useTransactionFiat } from "../hooks/use-transaction-fiat";

export const StyledGradienthBox = styled(Box)(({ theme }) => ({
  background: `linear-gradient(154.12deg, rgb(38, 38, 38) -27.695%,rgba(38, 38, 38, 0) 40.055%)`,
  position: "relative",
  padding: "100px 0",
  [theme.breakpoints.down("sm")]: {
    padding: "50px 0",
  },
}));

const Transactions = () => {
  const { userDataQuery } = useUserData();
  const { data: userData, isLoading: userLoading } = userDataQuery;

  const { tokensDataQuery } = useTokensData();
  const { data: tokensData, isLoading: tokensLoading } = tokensDataQuery;

  const { transactionFiatQuery } = useTransactionFiat();
  const { data: transactionFiat, isLoading: transactionFiatLoading } =
    transactionFiatQuery;

  const usdtBalance = userData?.balance?.cash || 0;
  const soilBalance = userData?.balance?.soil || 0;

  const totalTokensValue =
    tokensData?.reduce((sum, token) => {
      return sum + (token.amount || 0) * (token.priceToken || 0);
    }, 0) || 0;

  const totalBalance = usdtBalance + soilBalance + totalTokensValue;

  if (userLoading || tokensLoading || transactionFiatLoading) {
    return (
      <AppLayout>
        <LayoutContainer>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            py={10}
          >
            <Typography variant="h5" color="text.primary">
              Cargando tus datos...
            </Typography>
          </Box>
        </LayoutContainer>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <Stack py="40px">
        <StyledGradienthBox>
          <LayoutContainer>
            <Stack spacing={2}>
              <Typography variant="h2" color="text.secondary" maxWidth={1300}>
                Tu Balance
              </Typography>
              <Grid container spacing={4}>
                <Grid item xs={10} md={4}>
                  <BalanceCard
                    label="Balance Total Estimado"
                    amount={totalBalance}
                    symbol="USD"
                  />
                </Grid>
                <Grid item xs={10} md={4}>
                  <BalanceCard
                    label="Balance de USDT"
                    amount={usdtBalance}
                    symbol="USDT"
                  />
                </Grid>
                <Grid item xs={10} md={4}>
                  <BalanceCard
                    label="Balance de SOIL"
                    amount={soilBalance}
                    symbol="SL"
                  />
                </Grid>
              </Grid>
            </Stack>
          </LayoutContainer>
        </StyledGradienthBox>

        <Divider variant="fullWidth" orientation="horizontal" />

        <LayoutContainer>
          <Box py={5}>
            <Typography variant="h4" color="text.secondary" mb={3}>
              Tus Propiedades Tokenizadas
            </Typography>
            {tokensData?.length === 0 ? (
              <Box textAlign="center" py={5}>
                <Typography variant="h5" color="text.primary" mb={2}>
                  Aún no tienes propiedades tokenizadas.
                </Typography>
                <Typography variant="body1" color="text.secondary" mb={3}>
                  ¡Explora nuestro inventario y encuentra tu próxima inversión!
                </Typography>
                <Button variant="contained" color="primary" href="/">
                  Explorar Propiedades
                </Button>
              </Box>
            ) : (
              <Grid container spacing={3}>
                {tokensData?.map((token) => (
                  <Grid item xs={12} sm={6} md={4} key={token.id}>
                    <TokenCard token={token} />
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </LayoutContainer>

        <Divider variant="fullWidth" orientation="horizontal" />

        <LayoutContainer>
          <TransactionHistory data={transactionFiat || []} />
        </LayoutContainer>
      </Stack>
    </AppLayout>
  );
};

export default Transactions;
